import { FastField, FieldProps, getIn } from 'formik';
import { useCallback } from 'react';
import { ISelectProps, Select } from '../inputs/Select';
import { TextInputField } from './TextInputField';

export interface ISelectFieldProps extends FieldProps, ISelectProps {
  disabled?: boolean;
}

export const SelectField = ({ field, form, disabled, ...props }: ISelectFieldProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const handleChange = useCallback(
    (value: string) => {
      field.onChange({
        target: {
          value,
          name: field.name,
        },
      });

      props.onChange?.(value);
    },
    [field, props],
  );

  return (
    <>
      {disabled ? (
        <FastField {...field} {...props} disabled={disabled} component={TextInputField} />
      ) : (
        <Select
          {...field}
          {...props}
          options={props?.options}
          error={touched && !!error}
          helperText={(touched && error) || ''}
          onChange={handleChange}
        />
      )}
    </>
  );
};
